import { createContext } from 'react';

export const comparison = [
    {
        value: '==',
        name: 'is equal to'
    },
    {
        value: '<>',
        name: 'is not equal to'
    },
    {
        value: '>',
        name: 'is greater than'
    },
    {
        value: '>=',
        name: 'is greater or equal than'
    },
    {
        value: '<',
        name: 'is less than'
    },
    {
        value: '<=',
        name: 'is less or equal than'
    },
    {
        value: 'contains',
        name: 'contains'
    },
    {
        value: '!contains',
        name: 'not contains'
    },
    {
        value: '!present',
        name: 'not present'
    }
];

export const internalValues = [
    {
        label: 'true (bool)',
        value: 'SPECIAL::true'
    },
    {
        label: 'false (bool)',
        value: 'SPECIAL::false'
    },
    {
        label: 'empty',
        value: 'SPECIAL::empty'
    }
]

export const INTEGRATIONS_LOADING_STATE = "loading";

export const AUTOSAVE_DELAY = 4000;

const RunbookCanvasContext = createContext();
export default RunbookCanvasContext;
